import mixpanel from 'mixpanel-browser';
import config from '../../config/config';

mixpanel.init(config.mixpanel.TOKEN);

export default mixpanel;
